import styled from "styled-components";

export const Container = styled.div`
    padding: 250px 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
    h2{
        font-size: 6.25rem;
    }

    p{
        font-size: 1.2rem;
    }
`